import { Language } from "@faire/web-api/indigofair/languages/Language";
import { ILocaleKey } from "@faire/web-api/indigofair/locale/ILocaleKey";

import { THREE_LETTER_PRIMARY_COUNTRY_CODES } from "../consts/THREE_LETTER_PRIMARY_COUNTRY_CODES";
import {
  getFullLanguageName,
  THREE_TO_FULL_LANGUAGE_NAME,
} from "../consts/THREE_TO_FULL_LANGUAGE_NAME";

export const localeKeyToFullLanguageName = (localeKey: ILocaleKey) => {
  if (
    localeKey.language === Language.ENG &&
    localeKey.country === THREE_LETTER_PRIMARY_COUNTRY_CODES.GBR
  ) {
    return `${THREE_TO_FULL_LANGUAGE_NAME.ENG} (UK)`;
  }

  if (localeKey.language === Language.ENG) {
    return `${THREE_TO_FULL_LANGUAGE_NAME.ENG} (US)`;
  }

  if (localeKey.language === undefined) {
    return "";
  }

  return getFullLanguageName(localeKey.language);
};
